import videos from '../utils/videos';
const projets = {
    init() {
        videos.init();
        this.initPartenaires();
    },
    initPartenaires() {
        $(document)
            .off("click.projetsPartenaires", ".__partenaire > ._header")
            .on("click.projetsPartenaires", ".__partenaire > ._header", function () {

                let elt = $(this).parent();

                if (elt.hasClass("_open")) {
                    elt.removeClass("_open");
                    videos.stop(elt[0]);
                    return;
                }

                const others = $(".__partenaire._open").not(elt);
                others.removeClass("_open");

                others.each(function () {
                    videos.stop(this);
                });

                elt.addClass("_open");
            });
    },

    destroy() {
        $(document).off("click.projetsPartenaires", ".__partenaire > ._header");
        videos.destroy();
    }
};

export default projets;
